<template>
  <div class="tabs">
    <div class="tabs-header">
      <button
        v-for="(tab, i) in tabs"
        :key="tab.label"
        :class="['tab', { active: i === activeTab }]"
        @click="activeTab = i"
      >
        {{ tab.label }}
      </button>
    </div>
    <transition name="tab-fade" mode="out-in">
      <div class="tab-content" :key="activeTab">
        <slot :name="tabs[activeTab].slot"></slot>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";

const props = defineProps({
  tabs: {
    type: Array,
    required: true,
    // Exemplo: [{ label: 'Tab 1', slot: 'tab1' }, ...]
  },
  modelValue: {
    type: Number,
    default: 0
  }
});

const activeTab = ref(props.modelValue);
watch(() => props.modelValue, (v) => { activeTab.value = v; });
</script>

<style scoped lang="css">
.tabs {
  width: 100%;
  font-family: "Exo 2";
  font-weight: 600;
  font-size: 14px;
  line-height: 16.8px;
}

.tabs .active {
  border: 0px;
  background-color: #333333;
  color: #ffffff;
  border-radius: 25px;
  height: 34px;
}

.tabs :deep(.tab) {
  cursor: pointer;
  padding: 8px 17px;
}
.tabs-header {
  border: 1px solid #b5b5b5;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 31%;
  color: #979797;
  padding: 8px 10px;
  left: 50%;
  transform: translate(-50%) !important;
  margin-top: 20px;
}

.tab {
  transition: color 0.3s, border-bottom 0.3s;
  font-weight: 600;
}

.tab-content {
  margin-top: 1em;
  min-height: 60px;
}

.tab-fade-enter-active,
.tab-fade-leave-active {
  transition: opacity 0.3s;
}
.tab-fade-enter-from,
.tab-fade-leave-to {
  opacity: 0;
}

/* regras mobile 769px */
@media screen and (max-width: 769px) {
  .tabs {
    width: 100%;
    font-family: "Exo 2";
    font-weight: 600;
    font-size: 12px;
    line-height: 14.8px;
    min-width: 340px;
  }
  .tabs-header {
    width: 100%;
  }
}

@media screen and (min-width: 770px) and (max-width: 1200px) {
  .tabs-header {
    width: 50%;
  }
}
</style>
